import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../models/app-config.model';
import { log } from '../utils/logging';
import { TrsEventsService } from './trsevents.service';
import { ViolationDetails } from '../interfaces/Violation.interface';

@Injectable()
export class AppConfig {
    static settings: IAppConfig;

    constructor(private http: HttpClient, private trsService: TrsEventsService) { }
    load() {
        let jsonFile = `assets/config/app-config.json`;
        log.info(`Loading app config from ${jsonFile}`)
        return new Promise<void>((resolve, reject) => {
            window.errorObj = '';
            this.http.get(jsonFile).toPromise().then((response: any) => {
                log.info(`Loaded app config`)
                AppConfig.settings = <IAppConfig>response;
                resolve();
            }).catch((error: any) => {
                window.errorObj = 'Unable to load configurations';
                console.error('Configuration file could not be read', error);
                resolve();
            });
        });
    }

    static getMinimumRequirementsConfig = async (): Promise<any | null> => {
        const baseURL: string | null = AppConfig.GetServerBaseURL();
        if (baseURL != null && baseURL != '') {
            const selectedURL: string = `${baseURL}api/installer/config`;
            const headers = new Headers();
            headers.append("Content-Type", "application/json");

            try {
                const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

                if (apiResponse.ok)
                    return await apiResponse.json();
                else return null;
            } catch (error: any) {
                log.error(`Error in getMinimumRequirementsConfig`, error);
                return null;
            }
        }
        else {
            log.error(`TRSServerURL is not configured`, null);
            return null;
        }
    }

    static getPingResponse = async (): Promise<boolean> => {
        const baseURL: string | null = AppConfig.GetServerBaseURL();
        if (baseURL != null && baseURL != '') {
            const selectedURL: string = `${baseURL}ping`;
            const headers = new Headers();
            headers.append("Content-Type", "application/json");

            try {
                const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

                return apiResponse.ok;
            } catch (error: any) {
                log.error(`Error in getPingResponse`, error);
                return false;
            }
        }
        else {
            log.error(`TRSServerURL is not configured`, null);
            return false;
        }
    }

    static GetServerBaseURL = (): string | null => {
        if (AppConfig.settings.defaults.TRSServerURL != null && AppConfig.settings.defaults.TRSServerURL !== "") {
            const websocketURL: URL = new URL(AppConfig.settings.defaults.TRSServerURL);

            let url: string = '';

            if (websocketURL.protocol.includes('wss') === true)
                url = `https://`;
            else url = `http://`;

            url = `${url}${websocketURL.hostname}`;

            if (websocketURL.port !== "")
                url = `${url}:${websocketURL.port}`;

            url = `${url}/`;

            return url;
        }
        else return null;
    }

    static GetServerVersion = async (): Promise<string | null> => {
        const baseURL: string | null = AppConfig.GetServerBaseURL();
        if (baseURL != null && baseURL != '') {
            const selectedURL: string = `${baseURL}api/installer/config?configtype=serverversion`;
            const headers: Headers = new Headers();

            try {
                const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

                if (apiResponse.ok)
                    return await apiResponse.json();
                else return null;
            } catch (error: any) {
                log.error(`Error in GetServerVersion`, error);
                return null;
            }
        }
        else {
            log.error(`TRSServerURL is not configured`, null);
            return null;
        }
    }

    static GetViolationDetails = async (eventId: Number): Promise<ViolationDetails[]> => {
        const baseURL: string | null = AppConfig.GetServerBaseURL();
        if (baseURL != null && baseURL != '') {
            const selectedURL: string = `${baseURL}api/v1/utility?type=getviolationforeventid&eventid=${eventId}`;
            const headers: Headers = new Headers();

            try {
                const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

                if (apiResponse.ok)
                    return await apiResponse.json();
                else return [];
            } catch (error: any) {
                log.error(`Error in GetViolationDetails`, error);
                return [];
            }
        }
        else {
            log.error(`TRSServerURL is not configured`, null);
            return [];
        }
    }

    static GetClientName = (): string | null => {
        if (AppConfig.settings.defaults.TRSServerURL != null && AppConfig.settings.defaults.TRSServerURL !== "") {
            const websocketURL: URL = new URL(AppConfig.settings.defaults.TRSServerURL);

            if (websocketURL.hostname.split('.').length > 0)
                return websocketURL.hostname.split('.')[1];
            else return null;
        }
        else return null;
    }
}